exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".package[data-v-0a46b05b]{min-height:1000px;padding-bottom:90px}\n", ""]);

// exports
